import styled from 'styled-components';
import ProductItemPrice from '@components/ProductItemPrice';

const Price = styled(ProductItemPrice)`
  line-height: 18px;
  margin-left: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};
`;

export default Price;
